"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@emotion/react");
var react_helmet_async_1 = require("react-helmet-async");
/*
* meta tags for mobile browsers to match menu bar color
*/
function ThemeColorMeta(props) {
    var theme = (0, react_2.useTheme)();
    var themeColor = props.colorTheme === 'DARK' ? theme.colors.black : theme.colors.white;
    var appleTheme = props.colorTheme === 'DARK' ? 'black' : 'default';
    return (react_1.default.createElement(react_helmet_async_1.Helmet, null,
        react_1.default.createElement("meta", { name: "theme-color", content: themeColor }),
        react_1.default.createElement("meta", { name: "apple-mobile-web-app-capable", content: "yes" }),
        react_1.default.createElement("meta", { name: "apple-mobile-web-app-status-bar-style", content: appleTheme })));
}
exports.default = ThemeColorMeta;
